import { type FeedbackTriageResult } from '../../types/feedback';
import { FEEDBACK_CLASSIFICATION_COLORS } from '../../utils/feedback-labels';

const Field = ({ label, value }: { label: string; value: string }) => (
  <div>
    <p className="text-xs font-semibold uppercase tracking-wide text-text-grey">{label}</p>
    <p className="text-brand-blue mt-0.5">{value}</p>
  </div>
);

export const FeedbackTriagePanel = ({ triage }: { triage?: FeedbackTriageResult }) => {
  if (!triage) return null;

  const confidence = Math.round(triage.confidence * 100);
  const flags = [
    {
      show: triage.isCodeIssue,
      label: 'Code Issue',
      tone: 'border-blue-300 bg-blue-50 text-blue-700',
    },
    {
      show: triage.isKnowledgeIssue,
      label: 'Knowledge Issue',
      tone: 'border-orange-300 bg-orange-50 text-orange-700',
    },
    {
      show: triage.shouldCreateEval,
      label: 'Eval behövs',
      tone: 'border-teal-300 bg-teal-50 text-teal-700',
    },
    {
      show: triage.shouldCreateGithubIssue,
      label: 'GitHub Issue',
      tone: 'border-slate-300 bg-slate-50 text-slate-700',
    },
    {
      show: triage.shouldEscalationRule,
      label: 'Eskaleringsregel',
      tone: 'border-orange-300 bg-orange-50 text-orange-700',
    },
  ].filter((flag) => flag.show);

  return (
    <div className="rounded-xl border border-black/10 bg-white p-6">
      <h3 className="text-sm font-semibold text-brand-blue mb-4">Triage Resultat</h3>

      <div className="flex flex-wrap items-center gap-3 mb-4">
        {triage.classification ? (
          <span
            className={`inline-block rounded-sm border px-2.5 py-1 text-xs font-medium ${
              FEEDBACK_CLASSIFICATION_COLORS[triage.classification] ??
              'border-gray-300 text-gray-700 bg-gray-50'
            }`}
          >
            {triage.classification}
          </span>
        ) : null}

        <span className="text-xs text-text-grey">
          Confidence: <span className="font-medium text-brand-blue">{confidence}%</span>
        </span>
      </div>

      <div className="w-full h-2 rounded-full bg-black/5 mb-4 overflow-hidden">
        <div
          className="h-full rounded-full bg-brand-blue transition-all"
          style={{ width: `${confidence}%` }}
        />
      </div>

      <div className="space-y-3 text-sm">
        <Field label="Rubrik" value={triage.suggestedTitle} />
        <Field label="Sammanfattning" value={triage.suggestedSummary} />
        <Field label="Föreslagen fix" value={triage.suggestedFix} />

        {flags.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {flags.map((flag) => (
              <span
                key={flag.label}
                className={`rounded-sm border px-2 py-0.5 text-xs ${flag.tone}`}
              >
                {flag.label}
              </span>
            ))}
          </div>
        ) : null}

        {triage.suggestedEvalCase ? (
          <div className="rounded-sm border border-black/10 bg-brand-beige-tint-1 p-3">
            <p className="text-xs font-semibold uppercase tracking-wide text-text-grey mb-2">
              Föreslagen Eval Case
            </p>
            <pre className="text-xs text-brand-blue whitespace-pre-wrap font-mono">
              {JSON.stringify(triage.suggestedEvalCase, null, 2)}
            </pre>
          </div>
        ) : null}
      </div>
    </div>
  );
};
